import { Col, Container, Row } from "reactstrap";
import { Apps, ProjectLists } from "../../../../constants";
import ProjectListHead from "./ProjectListHead";
import ProjectStatusTabs from "./ProjectStatusTabs";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

const ProjectListContainer = () => {

  return (
    <>
      <Breadcrumbs mainTitle={ProjectLists} parent={Apps} />
      <Container fluid>
        <Row className="project-cards">
          <Col md="12" className="project-list">
            <ProjectListHead />
          </Col>
          <Col sm="12">
            <ProjectStatusTabs />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ProjectListContainer;